<template>

<!--
    Job Status Autocomplete Component

    @version 1.0
-->

<div class="input-group w-100 flex-nowrap border-0">

    <!-- job status auto complete -->
    <kt-autocomplete
        class="flex-grow-1"
        inputclass="form-control -rounded-end-0 form-control-sm"
        :options="list"
        rowvalue="Status"
        :rowkey="props.rowkey"
        :label="props.label"
        :placeholder="props.placeholder"
        @change="onChange"
        v-model="model"
        suffix-class="p-0"
    >
      
    <!-- drop down template -->
    <template #option="{ option }">
      <slot name="option" :option="option">
        <div class="dropdown-item autocomplete-option">
            {{ option.Status }}
        </div>
      </slot>
    </template>

    <!-- new status button (if needed in the future) 
    <template #suffix>
        <button 
            @click="editStatus()"
            class="btn btn-sm btn-outline-primary rounded-start-0"
        ><i class="fa fa-plus"></i>
        </button>
    </template>
    -->

    </kt-autocomplete>

</div>

</template>

<script setup>

import { ref, onMounted, computed } from "vue";
import { storeToRefs } from "pinia";
import { useJobStatusStore } from "@/stores/JobStatusStore";
import KtAutocomplete from "@/components/UI/KtAutocomplete.vue";

const props = defineProps(
{
    // sometimes we want the status id ...
    rowkey: {
        type: String,
        default: "Id"
    },

    label: {
        type: String,
        default: "Job Status"
    },

    inputClass: {
        type: String,
        default: ""
    },

    placeholder: {
        type: String,
        default: "Select a job status"
    },
});

const model = defineModel({
    type: String,
    default: ""
});

const emits = defineEmits(["change"]);
const jobStatusStore = useJobStatusStore();

// Convert the Record<number, JobStatusModel> to an array for the autocomplete
const list = computed(() => {
    const statusRecord = jobStatusStore.list;
    return Object.values(statusRecord);
});

const onChange = (value) =>
{
    emits("change", value);
}

const editStatus = async () =>
{
    // Placeholder for future status editing functionality
    console.log("Edit status functionality not implemented yet");
};

onMounted(async () =>
{
    await jobStatusStore.reload();
});

</script>
